import { h } from "preact";

import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";

import styles from "./BasicTag.module.css";

interface Props {
    class?: string;
    style?: CSSProperties;
    text: string;
    onClick?: (event: Event) => void;
}

function BasicTag({
    class: cssClass,
    style,
    text,
    onClick
}: Props) {
    return (
        <span
            class={classname("body-1", styles.basicTag, cssClass)}
            style={style}
            onClick={onClick}>
            {text}
        </span>
    );
}

export default BasicTag;
